import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ModalWindow from 'components/Modal/EditableModal/EditableModal'
import { useState } from 'react'
import { ALLOWED_PAYMENTS } from '../../../../../../components/Basket/constants'
import ButtonCinestar from '../../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../../../../components/Typography/Typography'
import InfoWindow from '../../../../../../components/Windows/InfoWindow/InfoWindow'
import CardOrderInfo from './CardOrderInfo/CardOrderInfo'
import MovieOrderInfo from './MovieOrderInfo/MovieOrderInfo'
import './OrderWindow.scss'
import TicketOrderInfo from './TicketOrderInfo/TicketOrderInfo'
import VoucherOrderInfo from './VoucherOrderInfo/VoucherOrderInfo'
import hocOrderWindow from './hocOrderWindow'

const extractTickets = (items_tickets) => {
    const ticketList = items_tickets?.reduce((ticketList, ticketObj) => {
        const ticketNumbers = ticketObj.tickets.map((ticket) => ticket.number)
        return [...ticketList, ...ticketNumbers]
    }, [])
    return ticketList
}

const extractVouchers = (items_vouchers) => {
    const voucherNumbers = items_vouchers?.map((voucher) => voucher.number)
    return voucherNumbers
}

const OrderWindow = ({
    order,
    cancelOrder,
    cancelReservation,
    restoreToCard,
    payReservation,
    loading,
    downloadTicketsAndVouchers,
}) => {
    const intl = useIntl()
    const [showRestoreToCardModal, setShowRestoreToCardModal] = useState(false)
    const [showBuyTicketModal, setShowBuyTicketModal] = useState(false)

    const itemsTickets = extractTickets(order.items.items_tickets)
    const itemsVouchers = extractVouchers(order.items.items_vouchers)

    const handleDownload = () => {
        downloadTicketsAndVouchers({ itemsTickets, itemsVouchers })
    }

    return (
        <Container fluid className={'order-ticket-card d-flex flex-column'}>
            <div className={'d-flex flex-column gap-1'}>
                <Typography variant={'h4'}>
                    {intl.formatMessage({
                        id: `userProfile.ticketsAndReserv.${
                            order.payment_method === ALLOWED_PAYMENTS.CASH ? 'reservationNumber' : 'orderNumber'
                        }`,
                    })}
                </Typography>
                <Typography variant={'h2'}>{order.number}</Typography>
            </div>

            {order.items.items_tickets.map(({ event, tickets }) => (
                <div key={`${event.eventid}-${event.title_groupid}`} className="d-flex flex-column">
                    <MovieOrderInfo event={event} />
                    <TicketOrderInfo tickets={tickets} />
                </div>
            ))}

            {order?.items?.items_vouchers?.length > 0 && <VoucherOrderInfo vouchers={order?.items?.items_vouchers} />}

            {order?.items?.items_cards?.length > 0 && <CardOrderInfo cards={order?.items?.items_cards} />}

            {order.payment_method !== ALLOWED_PAYMENTS.CASH ? (
                <>
                    <InfoWindow
                        color={'white'}
                        title={intl.formatMessage({ id: 'windows.notification.paidTitle' })}
                        description={intl.formatMessage({ id: 'windows.notification.reservationPaid' })}
                    />
                    <div className={'order-ticket-card--buttons d-flex'}>
                        {order.can_print && (
                            <ButtonCinestar
                                iconLeft={'download'}
                                variant={'primary-v1'}
                                className={'text-uppercase'}
                                onClick={() => handleDownload()}
                            >
                                {intl.formatMessage({ id: 'buttons.downloadTickets' })}
                            </ButtonCinestar>
                        )}
                        {order.can_cancel && (
                            <ButtonCinestar
                                disabled={loading}
                                iconLeft={'trash'}
                                variant={'secondary'}
                                className={'text-uppercase d-none'}
                                onClick={() =>
                                    cancelOrder({
                                        orderid: order.orderid,
                                    })
                                }
                            >
                                {intl.formatMessage({ id: 'buttons.cancelOrder' })}
                            </ButtonCinestar>
                        )}
                    </div>
                </>
            ) : (
                <div className={'order-ticket-card--buttons d-flex'}>
                    {
                        //Payment
                        order.can_change && (
                            <ButtonCinestar
                                disabled={loading}
                                iconLeft={'basket'}
                                variant={'primary-v1'}
                                className={'text-uppercase'}
                                onClick={() => setShowBuyTicketModal(true)}
                            >
                                {intl.formatMessage({ id: 'buttons.payReservation' })}
                            </ButtonCinestar>
                        )
                    }

                    {showBuyTicketModal && (
                        <ModalWindow
                            titleTextId={'modals.modalPayReservation.title'}
                            descriptionTextId={'modals.modalPayReservation.text'}
                            firstBtnTextId={'modals.modalPayReservation.backBtn'}
                            firstBtnClick={() => setShowBuyTicketModal(false)}
                            secondBtnTextId={'modals.modalPayReservation.continueBtn'}
                            secondBtnClick={() => payReservation(order.bookingid)}
                        />
                    )}

                    {
                        //Cancel
                        order.can_cancel && (
                            <ButtonCinestar
                                disabled={loading}
                                iconLeft={'trash'}
                                variant={'secondary'}
                                onClick={() =>
                                    cancelReservation({
                                        bookingid: order.bookingid,
                                    })
                                }
                            >
                                {intl.formatMessage({ id: 'buttons.cancelReservation' })}
                            </ButtonCinestar>
                        )
                    }

                    {order.can_restore_to_cart && (
                        <ButtonCinestar
                            disabled={loading}
                            variant={'secondary'}
                            onClick={() => setShowRestoreToCardModal(true)}
                        >
                            {intl.formatMessage({ id: 'buttons.restoreToCard' })}
                        </ButtonCinestar>
                    )}

                    {showRestoreToCardModal && (
                        <ModalWindow
                            titleTextId={'modals.modalRestoreToCard.title'}
                            descriptionTextId={'modals.modalRestoreToCard.text'}
                            firstBtnTextId={'modals.modalRestoreToCard.backBtn'}
                            firstBtnClick={() => setShowRestoreToCardModal(false)}
                            secondBtnTextId={'modals.modalRestoreToCard.continueBtn'}
                            secondBtnClick={() =>
                                restoreToCard({
                                    bookingid: order.bookingid,
                                })
                            }
                        />
                    )}
                </div>
            )}
        </Container>
    )
}

export default hocOrderWindow(OrderWindow)
